import HashManager from 'assets/core/js/module/hashManager'
import { HIDE_LOADING_TIMEOUT, PartialsLoadingEvents } from 'assets/core/js/module/partials'

export const scrollToAccommodation = function (callback?: (partialEl: HTMLElement, anchor: string) => void): void {
  const partialEl = document.querySelector<HTMLElement>('[data-partial-id="results"]')
  const anchor = HashManager.getAnchor()

  if (!partialEl || !anchor) {
    return
  }

  if (Object.keys(HashManager.getParameters()).length === 0) {
    callback?.(partialEl, anchor)

    // since there's a timeout on the hide loading event, we need to wait a bit more before going to the anchor
    setTimeout(() => {
      HashManager.goToAnchor(anchor)
    }, HIDE_LOADING_TIMEOUT + 50)
    return
  }

  partialEl.addEventListener(
    PartialsLoadingEvents.HIDDEN,
    () => {
      callback?.(partialEl, anchor)

      setTimeout(() => {
        HashManager.goToAnchor(anchor)
      }, 0)
    },
    { once: true }
  )
}
